import { BaseShippingZonesClient, ExpressPointsData, LocationAddress } from "@core/types";
import { convertShippingZone } from "./converters";
import { ShippingZonesSupaNoCode } from "./types";

class ShippingZonesClient extends BaseShippingZonesClient {
  async getShippingZones() {
    const { data } = await this.instance.get<ShippingZonesSupaNoCode[]>("/wp-json/wc/v3/shipping/zones");

    // Filtering - "Locations not covered by your other zones"
    const filterData = data.filter((shippingZone) => shippingZone.id !== 0);

    return filterData.map(convertShippingZone);
  }

  async getCheckAddressForExpress(address: LocationAddress): Promise<ExpressPointsData> {
    throw new Error("getCheckAddressForExpress not implemented");
  }
}

export default ShippingZonesClient;
